import { Button, Card, IconButton, TextField } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Delete, SearchOutlined } from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Pagination,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { City, Country, State } from "country-state-city";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import MAutocomplete from "../../components/MAutocomplete";
import MTextField from "../../components/MTextField";
import NodataComponent from "../../components/NodataComponent";
import { SnackbarType } from "../../constants/appConstants";
import { isFieldEmpty, isObjectEmpty } from "../../helpers/appFieldValidation";
import { getCopy, scrollToTop } from "../../helpers/utils.helper";
import { setSnackbar } from "../../reducers/snackbarReducer";
import "./city.scss";

export default function Cities(props) {
  const dispatch = useDispatch();
  const [location, setLocation] = useState({
    country: Country.getAllCountries(),
    state: [],
    city: [],
    viewCity: [],
  });
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = React.useState(false);

  const [locationObject, setLocationObject] = useState({});
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const handleDropdownChange = (value, type) => {
    if (!value) {
      return;
    }
    const updatedLocationObject = getCopy(locationObject);
    const updatedLocation = getCopy(location);
    let cityApiCalled = false;
    switch (type) {
      case "country":
        updatedLocationObject.country = value.name;
        updatedLocationObject.countryCode = value.isoCode;
        updatedLocationObject.state = "";
        updatedLocationObject.city = "";
        updatedLocation.state = State.getStatesOfCountry(
          updatedLocationObject.countryCode
        );
        updatedLocation.city = [];
        break;
      case "state":
        updatedLocationObject.state = value.name;
        updatedLocationObject.stateCode = value.isoCode;
        updatedLocationObject.city = "";
        updatedLocation.city = [];
        cityApiCalled = true;
        break;
      default:
        break;
    }
    setLocationObject(updatedLocationObject);
    setLocation(updatedLocation);
    if (cityApiCalled) {
      getCities(
        updatedLocationObject.countryCode,
        updatedLocationObject.stateCode
      );
    }
  };

  const getSortedCities = (cities) => {
    const nCities = cities.filter((c) => !isObjectEmpty(c));
    nCities.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }

      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    return nCities;
  };

  const getCities = (country, state) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_CITIES, null, {
      state: state,
      country: country,
    })
      .then((response) => {
        dispatch(stopLoading);
        if (
          response.data.status === Status.API_SUCCESS ||
          response.data.status === Status.API_NO_CONTENT
        ) {
          let city = City.getCitiesOfState(country, state);
          // console.log(response.data.data);
          let newCities = city.concat(response.data.data);
          let updatedLocation = getCopy(location);
          newCities = getSortedCities(newCities);
          updatedLocation.city = newCities;
          updatedLocation.filteredCity = newCities;
          updatedLocation.viewCity = newCities.slice(0, 50);
          setLocation(updatedLocation);
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error"));
      });
  };

  const getCitiesView = () => {
    return location["viewCity"].map((c) => (
      <TableRow>
        <TableCell>{c.name}</TableCell>
        <TableCell align="center">
          <Tooltip title={"View"}>
            <IconButton
              onClick={() => {
                console.log("delete", c._id);
                deleteCity(c._id);
              }}
            >
              <Delete color={"error"} />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };

  const deleteCity = (_id) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.DELETE_CITY + `/${_id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(
            setSnackbar(true, SnackbarType.SUCCESS, response.data.message)
          );
          getCities();
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        setSnackbar(true, SnackbarType.ERROR, "Cant Delete City");
      });
  };

  const onPageChange = (page) => {
    const offset = (page - 1) * 50;
    const finalIndex = offset + 50;
    const updatedLocation = getCopy(location);
    updatedLocation.viewCity = updatedLocation.filteredCity.slice(
      offset,
      finalIndex
    );
    setLocation(updatedLocation);
    scrollToTop();
  };

  const getSearchData = () => {
    const updatedLocation = getCopy(location);
    updatedLocation.filteredCity = updatedLocation.city.filter(
      (c) => c.name.indexOf(searchText) > -1
    );
    updatedLocation.viewCity = updatedLocation.filteredCity.slice(0, 50);
    setLocation(updatedLocation);
  };

  const resetSearchData = () => {
    setSearchText("");
    const updatedLocation = getCopy(location);
    updatedLocation.filteredCity = updatedLocation.city;
    updatedLocation.viewCity = updatedLocation.filteredCity.slice(0, 50);
    setLocation(updatedLocation);
  };

  const handleClickOpen = () => {
    const updatedLocation = getCopy(locationObject);
    updatedLocation.city = "";
    setLocationObject(updatedLocation);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const addCity = () => {
    if (
      isFieldEmpty(locationObject.city) ||
      isFieldEmpty(locationObject.countryCode) ||
      isFieldEmpty(locationObject.stateCode)
    ) {
      dispatch(
        errorSnackbar("Please select country, state and enter valid city.")
      );
      return;
    }
    handleClose();
    dispatch(startLoading);
    const payload = {
      name: locationObject.city,
      countryCode: locationObject.countryCode,
      stateCode: locationObject.stateCode,
    };
    AjaxHelper.postApi(navigate, Endpoint.ADD_CITY, payload)
      .then((response) => {
        dispatch(stopLoading);
        if (
          response.data.status === Status.API_SUCCESS ||
          response.data.status === Status.API_CREATED
        ) {
          dispatch(successSnackbar("City added successfully."));
          setSearchText("");
          const updatedLocation = getCopy(locationObject);
          updatedLocation.city = "";
          setLocationObject(updatedLocation);
          getCities(locationObject.countryCode, locationObject.stateCode);
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error on adding city."));
      });
  };

  const handleChange = (event) => {
    event.preventDefault();
    let updatedLocationObject = getCopy(locationObject);
    updatedLocationObject[event.target.name] = event.target.value;
    setLocationObject(updatedLocationObject);
  };

  return (
    <div className={"component-cities d-flex flex-column p-md-3"}>
      <div className="d-flex flex-row align-items-center justify-content-between p-md-0 p-3">
        <div className="d-flex flex-row justify-content-center align-content-center">
          <TextField
            fullWidth
            value={searchText}
            onKeyDown={(event) => {
              if (event.keyCode === 13) {
                getSearchData();
              }
            }}
            placeholder="Search"
            onChange={(event) => {
              setSearchText(event.target.value);
            }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => getSearchData()}>
                  <SearchOutlined />
                </IconButton>
              ),
            }}
          />
          <Button
            variant={"text"}
            className="button"
            onClick={() => resetSearchData()}
          >
            Reset
          </Button>
        </div>
        <Button
          variant="contained"
          className="mb-3 button"
          Style="margin-top: 25px;"
          color="primary"
          onClick={() => handleClickOpen()}
        >
          Add
        </Button>
      </div>
      <div className={"location p-md-0 p-3"}>
        <div className={"col-md-3 col-12"}>
          <MAutocomplete
            id={"country"}
            size="medium"
            onChange={(event, newValue) =>
              handleDropdownChange(newValue, "country")
            }
            options={location.country}
            placeholder={""}
            label={"Country"}
          />
        </div>
        <div className={"col-md-3 col-12"}>
          <MAutocomplete
            id={"state"}
            size="medium"
            className={"col-md-3"}
            onChange={(event, newValue) =>
              handleDropdownChange(newValue, "state")
            }
            options={location.state}
            placeholder={""}
            label={"State"}
          />
        </div>
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Name</span>
                </TableCell>
                <TableCell align="center">
                  <span className={"font-bold font-18"}>Actions</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {location.city.length > 0 ? getCitiesView() : null}
          </Table>
        </TableContainer>
        {location.city.length > 0 ? null : <NodataComponent />}
        {location.city.length > 0 ? (
          <Pagination
            className={"mpagination"}
            count={Math.ceil(location.filteredCity.length / 50)}
            variant="outlined"
            shape="rounded"
            onChange={(event, page) => onPageChange(page)}
          />
        ) : null}
      </Card>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>City form</span>
        </DialogTitle>
        <Divider />

        <div className={"city-form"}>
          <div
            className={
              "col-12 d-flex justify-content-center align-items-center px-3 mt-3"
            }
          >
            <MTextField
              id={"city"}
              name={"city"}
              className="col-12"
              type={"text"}
              required={true}
              label={"City"}
              value={locationObject.city}
              onChange={handleChange}
              placeholder={"eg. Mumbai"}
            />
          </div>
        </div>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => addCity()}>Add</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
